// src/services/newsServices.js
import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/news`;

// Récupère le token dynamiquement (utile après connexion)
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildQuery = (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (typeof v === "boolean") usp.append(k, v ? "true" : "false");
    else usp.append(k, String(v));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

// ========= Public =========

// Toutes les actualités (triées desc par le back)
export const getNews = async () => {
  try {
    const { data } = await axios.get(`${baseUrl}/getAllNews`, {
      headers: authHeaders(),
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Erreur lors du chargement des actualités:", error);
    return [];
  }
};

// 3 dernières actualités (Home)
export const getLatestNews = async () => {
  try {
    const { data } = await axios.get(`${baseUrl}/getLastThreeNews`, {
      headers: authHeaders(),
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Erreur lors du chargement des actualités:", error);
    return [];
  }
};

// Détail d’une actualité
export const getNewsById = async (id) => {
  if (!id) return null;
  try {
    const { data } = await axios.get(`${baseUrl}/${id}`, {
      headers: authHeaders(),
    });
    return data || null;
  } catch (error) {
    console.error("Erreur lors du chargement de l’actualité:", error);
    return null;
  }
};

// ========= Admin =========

// Recherche / pagination admin
// params: { q, is_active, page=1, limit=20, sort='created_at', dir='DESC' }
export const searchNews = async (params = {}) => {
  try {
    const qs = buildQuery(params);
    const { data } = await axios.get(`${baseUrl}/search${qs}`, {
      headers: authHeaders(),
    });
    return {
      items: Array.isArray(data?.items) ? data.items : [],
      total: Number.isFinite(data?.total) ? data.total : 0,
      page: Number.isFinite(data?.page) ? data.page : 1,
      limit: Number.isFinite(data?.limit) ? data.limit : 20,
      totalPages: Number.isFinite(data?.totalPages) ? data.totalPages : 1,
    };
  } catch (error) {
    console.error("Erreur recherche actualités:", error);
    return { items: [], total: 0, page: 1, limit: 20, totalPages: 1 };
  }
};

// Création
// payload: { title, content, image_url?, is_active? }
export const createNews = async (payload) => {
  try {
    const { data } = await axios.post(`${baseUrl}`, payload, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return data || null;
  } catch (error) {
    console.error("Erreur création actualité:", error);
    return null;
  }
};

// Remplacement (PUT)
export const updateNews = async (id, payload) => {
  if (!id) return null;
  try {
    const { data } = await axios.put(`${baseUrl}/${id}`, payload, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return data || null;
  } catch (error) {
    console.error("Erreur mise à jour actualité:", error);
    return null;
  }
};

// Mise à jour partielle (PATCH)
export const patchNews = async (id, partial) => {
  if (!id) return null;
  try {
    const { data } = await axios.patch(`${baseUrl}/${id}`, partial, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return data || null;
  } catch (error) {
    console.error("Erreur patch actualité:", error);
    return null;
  }
};

// Activer / désactiver
export const toggleNewsActive = async (id) => {
  if (!id) return null;
  try {
    const { data } = await axios.patch(`${baseUrl}/${id}/toggle`, null, {
      headers: authHeaders(),
    });
    return data || null;
  } catch (error) {
    console.error("Erreur toggle actualité:", error);
    return null;
  }
};

// Suppression
export const deleteNews = async (id) => {
  if (!id) return false;
  try {
    await axios.delete(`${baseUrl}/${id}`, {
      headers: authHeaders(),
    });
    return true;
  } catch (error) {
    console.error("Erreur suppression actualité:", error);
    return false;
  }
};
